import { __styles, mergeClasses, tokens } from '@fluentui/react-components';
export const copilotChatClassNames = {
  root: 'fai-CopilotChat'
};
/**
 * Styles for the root slot
 */
const useStyles = __styles({
  root: {
    mc9l5x: "f22iagw",
    Beiy3e4: "f1vx9l62",
    Belr9w4: "f1noh358"
  }
}, {
  d: [".f22iagw{display:flex;}", ".f1vx9l62{flex-direction:column;}", ".f1noh358{row-gap:var(--spacingVerticalM);}"]
});
/**
 * Apply styling to the CopilotChat slots based on the state
 */
export const useCopilotChatStyles_unstable = state => {
  const styles = useStyles();
  state.root.className = mergeClasses(copilotChatClassNames.root, styles.root, state.root.className);
  // TODO Add class names to slots, for example:
  // state.mySlot.className = mergeClasses(styles.mySlot, state.mySlot.className);
  return state;
};
//# sourceMappingURL=useCopilotChatStyles.js.map